import { ProjectSerieResponse } from '@/types/service-response'
import { ShiftEmployeeDetails } from '@/model/planning/ShiftEmployeeDetails'
import { AdditionalGroup } from '@/model/additional-fields/AdditionalGroup'
import _ from 'lodash'

export class EditShiftPlan {
  private constructor (
    readonly shiftId: number | null,
    readonly shiftName: string,
    readonly typeOfShift: string | null,
    readonly profitcenter: number | null,
    readonly department: number | null,
    readonly sachbearbeiter: number | null,
    readonly referenzTermin: string,
    readonly monday: string,
    readonly tuesday: string,
    readonly wednesday: string,
    readonly thursday: string,
    readonly friday: string,
    readonly saturday: string,
    readonly sunday: string,
    readonly whlg: string,
    readonly unique: string,
    readonly endAfterTimes: string,
    readonly endAfterDate: string,
    readonly provisorich: string,
    readonly fixed: string,
    readonly dateStart: string,
    readonly dateEnd: string,
    readonly projectSerieId: number | null,
    readonly projectId: number | null,
    readonly address: string,
    readonly referenzProjektId: number | null,
    readonly abonnementId: number | null,
    readonly details: Array<ShiftEmployeeDetails>,
    readonly additionalFields: AdditionalGroup[],
  ) {}

  public static createListFromResponse (data: ProjectSerieResponse[]): Array<EditShiftPlan> {
    return data.map((item: ProjectSerieResponse) => {

      const details: Array<ShiftEmployeeDetails> = ShiftEmployeeDetails.createListFromResponse(item.details)
      const additionalFields: AdditionalGroup[] = AdditionalGroup.createFromResponse(item.Zusatzfelder)

      return new EditShiftPlan(
        item.SchichtID,
        item.Schichtname,
        item.TypeOfShift,
        item.profitcenter,
        item.Abteilung,
        item.Sachbearbeiter,
        item.ReferenzTermin ? item.ReferenzTermin : '',
        item.Montag,
        item.Dienstag,
        item.Mittwoch,
        item.Donnerstag,
        item.Freitag,
        item.Samstag,
        item.Sonntag,
        item.Whlg,
        item.Einmalig,
        item.EndAfternTimes,
        item.EndAfterDate ? item.EndAfterDate : '',
        item.provisorisch,
        item.fixiert,
        item.datumStart ? item.datumStart : '',
        item.datumEnd ? item.datumEnd : '',
        item.ProjektSerieID,
        item.ProjektID,
        item.Adresse,
        item.ReferenzProjektID,
        item.AbonnementID,
        details,
        additionalFields
      )
    })
  }

  public static createSingleFromResponse (item: any): EditShiftPlan {
    const details: ShiftEmployeeDetails[] = ShiftEmployeeDetails.createListFromResponse(item.ds04.map((i: any) => {
      return {
        ArbeitID: i.Arbeit,
        Beruf: i.Beruf,
        BerufName: i.BerufName,
        Bildungsgrad: i.Bildungsgrad,
        BildungsgradName: i.BildungsgradName,
        DetailName: i.DetailName,
        Details: i.Details,
        Fachrichtung: i.Fachrichtung,
        FachrichtungName: i.FachrichtungName,
        Kompetenz: i.Kompetenz,
        KompetenzName: i.KompetenzName,
        MitarbeiterID: i.Mitarbeiter,
        NotizElement: i.Bemerkung,
        Planungsgruppe: i.Planungsgruppe,
        ProjektID: i.Projekt,
        Zeile: i.Zeile,
        datumEnde: i.DatumEnde,
        datumStart: i.DatumStart,
        detailID: i.ID,
      }
    }))

    const groupedByGroupeID = _.groupBy(item.ds02, 'GroupeID')

    const result = _.map(groupedByGroupeID, (itemsInGroup, groupeID) => {
      const firstItem = itemsInGroup[0]

      return {
        GroupCode: firstItem.GroupeCode,
        GroupID: firstItem.GroupeID,
        GroupName: firstItem.GrouppeName,
        Date: firstItem.ReferenzTermin,
        Projekt: firstItem.Projekt,
        Filters: _.map(itemsInGroup, (filterItem) => ({
          Art: filterItem.Art,
          Feldtyp: filterItem.FeldTyp,
          Items: _.chain(item.ds03)
            .filter(item => item.Feldtyp === filterItem.FeldTyp)
            .sortBy('Bezeichnung')
            .map(item => ({
              FilterItemBezeichnung: item.Bezeichnung,
              FilterItemInhalt: item.Inhalt,
              FilterItemId: item.ID
            }))
            .value(),
          Label: filterItem.Bezeichnung,
          Name: filterItem.Code,
          Value: filterItem.Inhalt,
          RTF: false,
          ML: false
        }))
      }
    })

    const additionalFields: AdditionalGroup[] = AdditionalGroup.createFromResponse(_.sortBy(result, 'GroupCode'))

    return new EditShiftPlan(
      item.ds01[0].SchichtID,
      item.ds01[0].Schichtname,
      item.ds01[0].TypeOfShift,
      item.ds01[0].profitcenter,
      item.ds01[0].Abteilung,
      item.ds01[0].Sachbearbeiter,
      item.ds01[0].ReferenzTermin ? item.ds01[0].ReferenzTermin : '',
      item.ds01[0].Montag.toString(),
      item.ds01[0].Dienstag.toString(),
      item.ds01[0].Mittwoch.toString(),
      item.ds01[0].Donnerstag.toString(),
      item.ds01[0].Freitag.toString(),
      item.ds01[0].Samstag.toString(),
      item.ds01[0].Sonntag.toString(),
      item.ds01[0].Whlg.toString(),
      item.ds01[0].Einmalig.toString(),
      item.ds01[0].EndAfternTimes === null ? '' : item.ds01[0].EndAfternTimes.toString(),
      item.ds01[0].EndAfterDate ? item.ds01[0].EndAfterDate : '',
      item.ds01[0].provisorisch ? 'True' : 'False',
      item.ds01[0].fixiert ? 'True' : 'False',
      item.ds01[0].datumStart ? item.ds01[0].datumStart : '',
      item.ds01[0].Datumende ? item.ds01[0].Datumende : '',
      item.ds01[0].ProjektSerieID,
      item.ds01[0].ProjektID,
      item.ds01[0].Adresse,
      item.ds01[0].ReferenzProjektID,
      item.ds01[0].AbonnementID,
      details,
      additionalFields
    )
  }
}
